/*
  BeSuro™ promotion eligibility (3ACES 2026-10-06).
  Reads the live BOGOS.io free-gift offers (window.fgData, loaded by the BOGOS app embed) and the Shopify cart, then
  tells shoppers what they've unlocked and how much more unlocks the next gift. Nothing is hard-coded: new offers,
  tiers, dates, include/exclude product lists and spend/quantity thresholds are picked up automatically.
  BOGOS itself adds/removes the gift lines; this only explains the state and keeps BeSuro UIs in sync.
  Renders into any element with [data-bs-gift-progress]. API: window.BesuroGifts.{evaluate(cart), message(cart), refresh()}.
*/
(function () {
  var T = window.BESURO_GIFT_TEXT || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SGD';
  function money(c) { try { return new Intl.NumberFormat(document.documentElement.lang || 'en-SG', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); } }
  function fill(s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function giftName(o) { var g = (o.gift_products || [])[0] || {}; var t = g.title || g.product_title || o.offer_name || o.title || ''; return String(t).replace(/^\s*🎁\s*/, '').replace(/\s*\(\s*100%\s*off\s*\)\s*$/i, '').replace(/^BeSuro(™)?\s+/i, '').trim(); }
  function giftIds(o) { return (o.gift_products || []).map(function (g) { return String(g.product_shopify_id || g.shopify_id || g.id); }); }
  function isGiftLine(it) { return /freegift|bogos/i.test(it.handle || '') || (it.properties && (it.properties._bogos_trigger || it.properties.__bogos_tracking)) || false; }
  function offers() {
    var d = window.fgData; if (!d || !d.offers) return [];
    var now = Date.now();
    return d.offers.filter(function (o) {
      if (o.deleted_at) return false;
      if (o.start_time && Date.parse(o.start_time) > now) return false;
      if (o.end_time && Date.parse(o.end_time) < now) return false;
      var c = (o.offer_conditions || [])[0];
      return c && (c.unit === 'money' || c.unit === 'number_of_products' || c.unit === 'quantity');
    });
  }
  function lineMatches(it, narrow) {
    if (!narrow || !narrow.length) return true;
    var n = narrow[0], val = n.value || {}, hit = false;
    if (n.type === 'variants_ids' || n.type === 'variant_ids') {
      Object.keys(val).forEach(function (pid) { (val[pid].variants || []).forEach(function (v) { if (String(v.id) === String(it.variant_id)) hit = true; }); if (!(val[pid].variants || []).length && String(pid) === String(it.product_id)) hit = true; });
    } else if (n.type === 'product_ids' || n.type === 'products' || n.type === 'product') {
      hit = Object.keys(val).some(function (pid) { return String(pid) === String(it.product_id); });
    } else { return null; } /* collections etc.: can't evaluate client-side */
    return n.filter_option === 'exclude' ? !hit : hit;
  }
  function evaluate(cart) {
    var items = (cart && cart.items) || [], res = [];
    var giftLines = items.filter(isGiftLine).map(function (i) { return String(i.product_id); });
    offers().forEach(function (o) {
      var c = o.offer_conditions[0], money_ = c.unit === 'money', sum = 0, ok = true;
      items.forEach(function (it) {
        if (isGiftLine(it)) return;
        var m = lineMatches(it, c.product_narrow); if (m === null) { ok = false; return; }
        if (m) sum += money_ ? it.final_line_price : it.quantity;
      });
      if (!ok) return;
      var min = money_ ? Math.round(Number(c.min_amount || 0) * 100 * rate) : Number(c.min_amount || 0);
      var max = c.max_amount == null || c.max_amount === '' ? Infinity : (money_ ? Math.round(Number(c.max_amount) * 100 * rate) : Number(c.max_amount));
      res.push({ offer: o, gift: giftName(o), money: money_, value: sum, min: min, max: max,
        qualifies: sum >= min && sum <= max,
        inCart: giftIds(o).some(function (id) { return giftLines.indexOf(id) > -1; }) });
    });
    return res;
  }
  function message(cart) {
    var r = evaluate(cart); if (!r.length) return null;
    var got = r.filter(function (x) { return x.qualifies; }); /* judge by the rules, not by a gift line BOGOS hasn't removed yet */
    var next = r.filter(function (x) { return x.value < x.min; }).sort(function (a, b) { return a.min - b.min; })[0];
    var parts = [];
    if (got.length) parts.push({ kind: 'got', text: fill(T.unlocked, { gift: got.map(function (x) { return x.gift; }).join(' + ') }) });
    if (next) parts.push({ kind: 'next', pct: next.min > 0 ? Math.max(4, Math.min(100, Math.round(next.value / next.min * 100))) : 0, text: fill(next.money ? T.add_more : T.add_items, { amount: next.money ? money(next.min - next.value) : (next.min - next.value), gift: next.gift }) });
    return parts.length ? parts : null;
  }
  function render(cart) {
    var els = document.querySelectorAll('[data-bs-gift-progress]'); if (!els.length) return;
    var parts = message(cart);
    els.forEach(function (el) {
      if (!parts) { el.hidden = true; el.innerHTML = ''; return; }
      el.hidden = false;
      el.innerHTML = parts.map(function (p) {
        var txt = p.text.replace(/[<>]/g, ''), kick = String((p.kind === 'got' ? T.kick_got : T.kick_next) || '').replace(/[<>]/g, '');
        return '<div class="bsgp__' + p.kind + '"><span class="bsgp__ic" aria-hidden="true">' + (p.kind === 'got' ? '🎁' : '🚀') + '</span><div class="bsgp__txt">' +
          (kick ? '<b class="bsgp__kick">' + kick + '</b>' : '') + '<span>' + txt + '</span>' +
          (p.kind === 'next' ? '<span class="bsgp__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + p.pct + '"><i style="width:' + p.pct + '%"></i></span>' : '') +
          '</div></div>';
      }).join('');
    });
  }
  var last = null;
  async function refresh() {
    try { last = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json(); render(last); document.dispatchEvent(new CustomEvent('besuro:cart-synced', { detail: last })); } catch (e) {}
    return last;
  }
  /* BOGOS edits the cart a moment after any change — re-read it so totals and gifts shown are never stale */
  var timers = [];
  function settle() { timers.forEach(clearTimeout); timers = [700, 1800, 3500].map(function (ms) { return setTimeout(refresh, ms); }); }
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) p.then(settle, settle);
    return p;
  };
  window.BesuroGifts = { evaluate: evaluate, message: message, refresh: refresh, render: render };
  function boot(n) { if (window.fgData || n > 40) { refresh(); } else { setTimeout(function () { boot(n + 1); }, 250); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); }); else boot(0);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
